import React, {Component} from "react";
import $ from "jquery";

class DongPrivate extends Component {
  componentDidMount() {
    $(document).ready(function () {
      $('.Subnav').addClass('hide');
      $('.Subnav ul').addClass('hide');
    });
  }

  render() {
    return (
      <div className="terms">
        <h3 className="title">■ 개인정보 수집/이용/위탁/제 3자 제공 동의서</h3>
        <p>띵동 서비스, SMartro VAN, SMartroPAY, KT무선 개통 및 카드가맹점번호 신청 대행 서비스 신청과 관련된 개인·신용정보 등은 ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’, ‘개인정보보호법’, ‘신용정보의 이용 및 보호에 관한 법률’ 등의 규정에 따라 수집, 이용, 제공 및 취급위탁하기 위하여 본인의 동의를 얻어야 하는 정보입니다. 이에 본인은 주식회사 띵동이 아래의 내용과 같이 본인의 개인 신용정보를 수집, 이용, 제공 및 취급 위탁하는 것에 동의합니다.</p>

        <h3>「개인정보 수집·이용·위탁 동의서」</h3>
        <table>
          <colgroup>
            <col style={{width: '20%'}}/>
            <col style={{width: "80%"}}/>
          </colgroup>
          <tbody>
          <tr style={{height: "40px"}}>
            <th>구분</th>
            <th>필수항목</th>
          </tr>
          <tr>
            <th>수집·이용·제공 목적</th>
            <td>
              <ul>
                <li>·띵동 서비스, SMartro VAN, SMartroPAY, ㈜쏘다, ㈜유디아이디, KT무선 개통 및 카드가맹점번호 신청 대행 서비스 신청에 따른 서비스 제공, 유지, 이행, 관리 목적</li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>수집·이용·제공 항목</th>
            <td>
              <ul>
                <li>·개인정보 : 성명, 법정생년월일, 외국인등록번호, 주소, 이메일, 휴대폰번호, 전화번호</li>
                <li>·가맹점정보 : 상호, 대표자명, 법인등록번호, 업종, 업태, 사업장주소, 전화번호, 팩스번호, 사업자등록번호</li>
                <li>·거래번호 : 매출정보, 멤버쉽 거래내역</li>
                <li>·CMS 출금 결제 관련 정보 : 예금주명, 거래은행, 출금계좌번호</li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>보유·이용 기간</th>
            <td>
              <ul>
                <li>·개인정보, 가맹점정보(상호, 업종, 업태, 사업장주소, 전화번호, 팩스번호, 사업자등록번호) 제외 : 최종 거래일로부터 2년까지</li>
                <li>·거래정보 : 거래종료일로부터 5년까지</li>
              </ul>
            </td>
          </tr>
          <tr style={{height: "40px"}}>
            <th>동의 거부 권리/불이익</th>
            <td>동의가 없을 경우 계약체결 및 이에 따른 서비스 제공 또는 유지가 불가능 함</td>
          </tr>
          </tbody>
        </table>

        <h3>「개인정보 제 3자 제공 동의서」</h3>
        <table>
          <colgroup>
            <col style={{width: "20%"}}/>
            <col style={{width: "80%"}}/>
          </colgroup>
          <tbody>
          <tr style={{height: "40px"}}>
            <th>구분</th>
            <th>필수항목</th>
          </tr>
          <tr>
            <th>제공받는 자</th>
            <td>
              <ul>
                <li>·신용/체크/선불/직불카드 및 현금 IC : 해당 서비스 제공 카드사 및 은행, 알리페이/위젯페이/삼성전자(주)</li>
                <li>·전자화폐 : ㈜한국스마트카드, ㈜이비카드, ㈜마이비, 부산은행, (사)금융결제원</li>
                <li>·멤버쉽 서비스 제공사(카드사/이동통신사 등) 및 국세청 등 공공기관</li>
                <li>·업무제휴사(제공 목적에 기입한 업무처리를 수탁 받은 업체 포함)</li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>제공받는 자의 이용 목적</th>
            <td>
              <ul>
                <li>·신용/체크/선불/직불카드, 전자화폐, 현금영수증, 멤버쉽 서비스 : 가맹점 정보 확인 및 거래승인, 청구, 취소, 매입, 정산, 분쟁해결, 통계자료 활용 및 전자서명 보관 등
                </li>
                <li>·자동이체 출금 결제 관련 고객관리 ·카드 가맹점 가입 ·단말기 무선 통신 개통</li>
                <li>·신용판매대금 자동 입금서비스 제공, 문자발송, 우편발송, 이메일발송, 전화상담, 채권추심, 인터넷, 및 휴대폰관련 서비스 제공, 고객관리</li>
                <li>·공공기관 제공 : 세무자료 수집, 금융사고 조사, 범죄 수사 등</li>
                <li>·부가(제휴)서비스 설정/유지/이행/관리 등 업무 수행</li>
                <li>·개인 정보를 제공받는 회사들의 상품/서비스 소개 및 판매, 시장조사를 기반으로 한 분석 서비스 제공, 사은·판촉행사, 상품·서비스 개발, 연구, 마케팅 활동 등</li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>제공 할 개인정보 항목</th>
            <td>
              <ul>
                <li>·개인정보 : 성명, 법정생년월일, 외국인등록번호, 주소, 이메일, 휴대폰번호, 전화번호</li>
                <li>·가맹점정보 : 상호, 대표자명, 법인등록번호, 업종, 업태, 사업장주소, 전화번호, 팩스번호, 사업자등록번호, 예금주명, 거래은행, 출금계좌번호</li>
                <li>·거래정보 : 매출정보(신용, 체크, 선불, 현금, 현금IC 등), 멤버쉽 거래내역</li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>보유·이용기간</th>
            <td>
              <ul>
                <li>·개인정보, 가맹점정보 : 이용계약 해지 또는 변경 시 단, 관련법규 등에 의하여 보존이 필요할 경우 그 해당기간</li>
                <li>·거래정보 : 거래종료일로부터 5년까지</li>
              </ul>
            </td>
          </tr>
          <tr style={{height: "40px"}}>
            <th>동의 거부 권리/불이익</th>
            <td>동의가 없을 경우 계약체결 및 이에 따른 서비스 제공 또는 유지가 불가능 함</td>
          </tr>
          </tbody>
        </table>

        <h3 className="title" style={{marginTop: "50px"}}>■ 마케팅 정보 수집·활용 동의서</h3>

        <p>＂띵동(이하, '서비스'라 합니다.)"의 서비스 제공 및 이용과 관련하여 ㈜띵동(이하, '회사'라 합니다)이 취득한 개인정보는 "통신비밀보호법", "전기통신사업법" 및 "정보통신망 이용촉진 및 정보보호 등에 관한 법률" 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보 보호 규정을 준수합니다.<br/><br/>
          1. 서비스에서는 고객이 수집 및 이용에 동의한 개인정보를 활용하여, 전자적 전송 매체(SMS/MMS/e-mail/App Push 등 다양한 전송 매체)를 통하여, 회사 및 제3자의 상품 또는 서비스에 대한 개인 맞춤형 광고 정보를 전송할 수 있습니다.<br/>
          2. 고객이 본 수신 동의를 철회하고자 할 경우 고객센터를 통하여 수신 동의 철회 요청을 할 수 있습니다.
        </p>
        <table>
          <colgroup>
            <col style={{width: "20%"}}/>
            <col style={{width: "80%"}}/>
          </colgroup>
          <tbody>
          <tr style={{height: "40px"}}>
            <th>구분</th>
            <th>필수항목</th>
          </tr>
          <tr>
            <th>이용항목</th>
            <td>
              <ul>
                <li>- 개인 식별 정보: 성명, 성별, 전화번호, 이메일, 주소 등</li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>이용목적</th>
            <td>
              <ul>
                <li>-마케팅 광고에 활용</li>
                <li>1) 시장 조사, 서비스 개발 및 개선, 서비스 관련 문의 등에 대한 개인 맞춤 상담 정보 제공</li>
                <li>2) 신규 서비스나 이벤트, 제3자의 상품 또는 서비스 관련 개인 맞춤형 광고 정보 전송</li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>보유 기간</th>
            <td>
              <ul>
                <li>-동의일로부터 별도 마케팅 동의 해제 시까지 보유·이용</li>
              </ul>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export {DongPrivate}